import { Model } from "@vuex-orm/core";
import moment from "moment";

export default class CompanyUserResources extends Model {
  static entity = "companyUserResources";
  static fields() {
    return {
      companyUserId: this.attr(null),
      resourceId: this.attr(null),
      operation: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
    }
  }

}
